
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14.944 4.822a1.076 1.076 0 111.522 1.521 1.076 1.076 0 01-1.522-1.521zm2.583-1.061a2.576 2.576 0 10-3.644 3.643 2.576 2.576 0 003.644-3.643zM7.056 11.239a1.076 1.076 0 10-1.522 1.522 1.076 1.076 0 001.522-1.522zm-2.583-1.06a2.576 2.576 0 113.644 3.643 2.576 2.576 0 01-3.644-3.644zm11.993 7.477a1.076 1.076 0 10-1.522 1.522 1.076 1.076 0 001.522-1.522zm-2.583-1.06a2.576 2.576 0 113.644 3.643 2.576 2.576 0 01-3.644-3.643z"}})])
          )
        }
      }
    